export const PASSIVE_WINDOW_START = 1.0; // 01:00
export const PASSIVE_WINDOW_END   = 5.0; // 05:00

export const parseNotteAttivaIntervalli = (str) => {
  if (!str) return [];
  return str.split('|').map(iv => {
    const [inizio, fine] = iv.split('~');
    return { inizio, fine };
  });
};

// Ore da NON contare per un turno: intersezione con 01:00-05:00 meno le emergenze attive
export const calcDeduzioneNottePassiva = (t) => {
  if (!t.start_time || !t.end_time) return 0;
  const [sH, sM] = t.start_time.split(':').map(Number);
  const [eH, eM] = t.end_time.split(':').map(Number);
  const start = sH + sM / 60;
  let end = eH + eM / 60;
  if (end < start) end += 24;

  const winStart = Math.max(start, PASSIVE_WINDOW_START);
  const winEnd   = Math.min(end,   PASSIVE_WINDOW_END);
  if (winEnd <= winStart) return 0;

  let passive = winEnd - winStart;

  parseNotteAttivaIntervalli(t.notte_attiva_intervalli).forEach(iv => {
    const [ivH, ivM] = iv.inizio.split(':').map(Number);
    const [ifH, ifM] = iv.fine.split(':').map(Number);
    const actS = Math.max(winStart, ivH + ivM / 60);
    const actE = Math.min(winEnd,   ifH + ifM / 60);
    if (actE > actS) passive -= (actE - actS);
  });

  return passive > 0 ? passive : 0;
};

// True se il turno ha almeno un minuto nella finestra 01:00-05:00
export const overlapsPassiveWindow = (shift) => {
  if (!shift.start_time || !shift.end_time) return false;
  const [sH, sM] = shift.start_time.split(':').map(Number);
  const [eH, eM] = shift.end_time.split(':').map(Number);
  const start = sH + sM / 60;
  let end = eH + eM / 60;
  if (end < start) end += 24;
  return end > PASSIVE_WINDOW_START && start < PASSIVE_WINDOW_END;
};
